<div class="dialog__container">
  <div class="dialog__container-header">
    <div class="dialog__container-header-title">
      <div class="dialog__container-heading">Quick Chat - {{programPartner.displayName}}</div>
      <span class="dialog__container-sub-heading">
        @if (data.taskName) {
          {{data.taskName}} •
          }ID: {{programPartner.recordNumber}}
        </span>
      </div>
      <button disableRipple mat-icon-button type="button" class="send__close-btn" aria-label="Close Send Message" [mat-dialog-close]="false" data-pw="close-message-dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  <div class="line"></div>
  <mat-dialog-content class="dialog__container-content">
    @if (sendingMessage) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="dialog__container-recipient-selection">
      <div class="grow w-full">
        <mat-label>Send to</mat-label>
        <mat-form-field>
          <mat-select
            [(value)]="selectedRecipientId"
            (selectionChange)="onRecipientSelectionChange()"
            [disabled]="sendingMessage || !canSelectRecipient || recipientOptions.length === 0"
            placeholder="Recipient: Please Select"
            data-pw="recipient">
            @for (recipient of recipientOptions; track recipient.id) {
              <mat-option [value]="recipient.id">{{ getRecipientLabel(recipient) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="dialog__container-category-selection">
      <div class="grow w-full">
        <mat-form-field>
          <mat-select [(value)]="selectedCategory" (selectionChange)="categoryChange()"
            [disabled]="sendingMessage"
            placeholder="Category: Please Select" data-pw="category">
            @for (item of categories; track $index) {
              <mat-option [value]="item">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="grow w-full">
        <mat-form-field class="dialog__container-subcategory-selector">
          <mat-select [(value)]="selectedSubcategory"
            [placeholder]="subCategories === null || subCategories.length === 0  ? 'NA' : 'Please Select'"
            data-pw="subcategory"
            [disabled]="!subCategories || subCategories.length === 0 || sendingMessage">
            @for (item of subCategories; track $index) {
              <mat-option [value]="item">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="dialog__container-message-row">
      <div class="grow w-full">
        <mat-form-field appearance="outline" class="send-message-text-area w-full" style="padding: 0; padding-right: 8px;">
          <textarea matInput [(ngModel)]="messageContent"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="2"
            [cdkAutosizeMaxRows]="15"
            maxlength="500"
            placeholder="Type your message here..."
            class="dialog__container-textarea"
          [disabled]="!isCategoryValid || sendingMessage"></textarea>
          <mat-hint [class.disable-hint]="!canSendMessage || sendingMessage">{{messageContent.length}} / 500 characters</mat-hint>
        </mat-form-field>
      </div>
      <div class="dialog__container-send-btn">
        <button mat-fab class="k12__primary-button" (click)="btnSendMessage()"
          [disabled]="!canSendMessage || sendingMessage"
          aria-label="Send Message" data-pw="send-message">
          <mat-icon svgIcon="k12-message-send"></mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-content>
